// third-party

// assets
import {
  LineChartOutlined,
  IdcardOutlined,
  DatabaseOutlined,
  BuildOutlined,
  CalendarOutlined,
  CustomerServiceOutlined,
  MessageOutlined,
  ShoppingCartOutlined,
  UserOutlined,
  AppstoreAddOutlined,
  FileTextOutlined
} from '@ant-design/icons';

// type
import { NavItemType } from 'types/menu';

// icons
const icons = {
  BuildOutlined,
  CalendarOutlined,
  CustomerServiceOutlined,
  MessageOutlined,
  ShoppingCartOutlined,
  UserOutlined,
  AppstoreAddOutlined,
  FileTextOutlined,
  LineChartOutlined,
  IdcardOutlined,
  DatabaseOutlined
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const scenarioAnlysis: NavItemType = {
  id: 'group-scenario-anlysis',
  title: 'Scenario Anlysis',
  icon: icons.IdcardOutlined,
  type: 'group',
  children: [
    {
      id: 'scenario-anlysis-assets',
      title: 'Assets',
      type: 'collapse',
      icon: icons.FileTextOutlined,
      breadcrumbs: true,
      children: [
        {
          id: 'scenario-anlysis-karachaganak',
          title: 'Karachaganak',
          type: 'item',
          url: '/scenario-anlysis/asset/Karachaganak'
        },
        {
          id: 'scenario-anlysis-tengiz',
          title: 'Tengiz',
          type: 'item',
          url: '/scenario-anlysis/asset/Tengiz'
        },
        {
          id: 'scenario-anlysis-kashagan',
          title: 'Kashagan',
          type: 'item',
          url: '/scenario-anlysis/asset/Kashagan'
        },
        {
          id: 'scenario-anlysis-kalamkas-offshore',
          title: 'Kalamkas offshore',
          type: 'item',
          url: '/scenario-anlysis/asset/Kalamkas-offshore'
        }
      ]
    }
  ]
};

export default scenarioAnlysis;
